export default {"src":"/_next/static/media/racing.19bf45fc.svg","height":567,"width":86};